/**
 * @type {Object}
 * @property {array}
 */
const initialState = {
    paymentConditions: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerPaymentCondition = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_PAYMENT_CONDITIONS_DATA':
            var { data } = action;
            newState.paymentConditions = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerPaymentCondition;